import { ACCESS_TOKEN_NAME, REFRESH_TOKEN_NAME } from "../shared/constants";
import { SETTINGS, USER, AUTH, COMPANY, SERVICE_CENTERS } from "../shared/tagTypes";
import { IApiResponse, ILoginResponse } from "../types/User";
import { baseApi } from "./base";

export const authApi = baseApi
    .enhanceEndpoints({
        addTagTypes: [AUTH, SETTINGS, USER, COMPANY, SERVICE_CENTERS],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            authLogin: builder.mutation<IApiResponse<ILoginResponse>, void>({
                query: (payload) => ({
                    url: "/auth/login",
                    method: "POST",
                    body: payload
                })
            }),
            register: builder.mutation({
                query: (payload) => ({
                    url: "/auth/register",
                    method: "POST",
                    body: payload
                })
            }),
            sendOtp: builder.mutation({
                query: (payload) => ({
                    url: "/auth/send-otp",
                    method: "POST",
                    body: payload
                })
            }),
            verifyOtp: builder.mutation({
                query: (payload) => ({
                    url: "/auth/verify-otp",
                    method: "POST",
                    body: payload
                })
            }),
            resetPassword: builder.mutation({
                query: (payload) => ({
                    url: "/auth/reset-password",
                    method: "POST",
                    body: payload
                })
            }),
            authAdminLogin: builder.mutation<IApiResponse<ILoginResponse>, void>({
                query: (payload) => ({
                    url: "/auth/admin-login",
                    method: "POST",
                    body: payload
                })
            }),
            refreshToken: builder.mutation<IApiResponse<ILoginResponse>, void>({
                query: () => ({
                    url: "/auth/refresh-token",
                    method: "POST",
                    body: {
                        accessToken: localStorage.getItem(ACCESS_TOKEN_NAME),
                        refreshToken: localStorage.getItem(REFRESH_TOKEN_NAME)
                    }
                })
            }),
            registerServiceCenter: builder.mutation({
                query: (payload) => ({
                    url: "/serial-no/register-service-center",
                    method: "POST",
                    body: payload
                })
            }),
            registerServiceTaker: builder.mutation({
                query: (payload) => ({
                    url: "/serial-no/register-service-taker",
                    method: "POST",
                    body: payload
                })
            }),
            getOrganizations: builder.query({
                query: (payload) => ({
                    url: "/serial-no/organizations",
                    params: {
                        businessTypeId: payload.businessTypeId,
                        srcText: payload.srcText
                    }
                }),
                providesTags: [COMPANY],
            }),
            getAllServiceCenters: builder.query({
                query: (payload) => ({
                    url: "/serial-no/all-service-centers",
                    params: {
                        srcText: payload.srcText
                    }
                }),
                providesTags: [SERVICE_CENTERS],
            }),
        }),

        overrideExisting: false,
    });

export const {
    useAuthLoginMutation,
    useRegisterMutation,
    useSendOtpMutation,
    useVerifyOtpMutation,
    useResetPasswordMutation,
    useAuthAdminLoginMutation,
    useRegisterServiceCenterMutation,
    useRegisterServiceTakerMutation,
    useGetOrganizationsQuery,
    useLazyGetOrganizationsQuery,
    useGetAllServiceCentersQuery,
    useLazyGetAllServiceCentersQuery
} = authApi;
